import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
  Divider,
} from '@mui/material';
import { useLazyGetPublicNewsQuery } from '../../gnnApiSlice';
import { useTheme } from '@emotion/react';
import { Close, EmojiEmotions, ThumbUp, Comment } from '@mui/icons-material'; // Add icons for like and comment
import defaultimg from '../default.png';
import PublicNavbar from './PublicNavbar';

const PublicNews = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [getPublicNews] = useLazyGetPublicNewsQuery();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchPublicNews = async () => {
      setLoading(true);
      try {
        const data = await getPublicNews({ page: 1, pageSize: 4 }).unwrap();
        setNewsData(data.data);
      } catch (error) {
        console.error('Error fetching public news:', error);
      }
      setLoading(false);
    };

    fetchPublicNews();
  }, [getPublicNews]);

  // Handler to open dialog
  const handleCardClick = () => {
    setDialogOpen(true);
  };

  // Handler to close dialog
  const handleClose = () => {
    setDialogOpen(false);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
      <PublicNavbar />
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90.5vh',
          overflow: 'auto',
          padding: isXs || isSm ? '10px' : '20px',
        }}
      >
        {newsData.map((news) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            key={news._id}
            sx={{
              marginBottom: '1rem',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Card
              sx={{
                background: 'white',
                boxShadow: 2,
                border: 1,
                borderColor: 'divider',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                // maxWidth: '345px',
                cursor: 'none', // Change cursor to pointer for clickable effect
              }}
              onClick={handleCardClick} // Attach click handler
            >
              <CardMedia
                component="img"
                image={
                  news.attachments[0] ? `${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${news.attachments[0]}` : defaultimg
                }
                alt="News image"
                sx={{ height: '180px', objectFit: 'cover', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultimg;
                }}
              />
              <CardContent sx={{ padding: isXs || isSm ? '10px' : '16px' }}>
                <Typography
                  variant={isXs || isSm ? 'subtitle1' : 'h6'}
                  sx={{ fontWeight: 'bold', mb: 1 }}
                  dangerouslySetInnerHTML={{ __html: news.title }}
                />
                <Typography sx={{ fontSize: '12px', mb: 2 }} dangerouslySetInnerHTML={{ __html: news.description }} />
                <Typography variant="body2" sx={{ mb: 2, color:'grey', fontSize:'12px' }}>
                  Posted on {new Date(news.createdAt).toLocaleDateString()}
                </Typography>
              </CardContent>

              {/* Like and Comment Options */}
              <Box sx={{ display: 'flex', justifyContent: 'space-around', padding: '8px 16px', borderTop:1, borderColor:'divider', borderRadius:'4px' }}>
                <IconButton  onClick={handleCardClick} sx={{color:'grey'}}>
                  <ThumbUp /><Typography sx={{ml:1}}>{" "}Like</Typography>
                </IconButton>
                <Divider orientation="vertical" flexItem sx={{ }} />
                <IconButton onClick={handleCardClick} sx={{color:'grey'}}>
                  <Comment /><Typography sx={{ml:1}}>{" "}Comment</Typography>
                </IconButton>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Dialog for login prompt */}
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 16px',
          }}
        >
          <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{'Whoa, hold up! 🚀'}</span>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{ p: 0, mr: 0.1 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ padding: '16px' }}>
          <DialogContentText
            sx={{
              color: 'black',
              textAlign: 'center',
              fontSize: '1rem',
              lineHeight: 1.5,
              mt: 1,
            }}
          >
            To keep exploring, we need you to log in.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '16px' }}>
          <Button
            onClick={() => {
              handleClose();
              window.location.href = '/auth'; // Redirect to login page
            }}
            size="small"
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: '#0A4FAC',
              textDecoration: 'none',
              textTransform: 'none',
              fontSize: '1rem',
            }}
          >
            Login and explore more!
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PublicNews;
